const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger'
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen'
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel'

class AnimateOnScroll extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    if (!this.isDisabled) this._initializeScrollAnimationTrigger()
  }

  _onIntersection(elements, observer) {
    elements.forEach((element, index) => {
      if (element.isIntersecting) {
        const elementTarget = element.target
        if (
          elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
        ) {
          elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
          if (elementTarget.hasAttribute('data-cascade'))
            elementTarget.setAttribute('style', `--animation-order: ${index};`)
        }
        observer.unobserve(elementTarget)
      } else {
        element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
        element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME)
      }
    })
  }

  _initializeScrollAnimationTrigger() {
    const animationTriggerElements = Array.from(
      this.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
    )
    if (animationTriggerElements.length === 0) return

    const observer = new IntersectionObserver(this._onIntersection, {
      rootMargin: '0px 0px -50px 0px',
    })
    animationTriggerElements.forEach((element) => observer.observe(element))
  }

  get isDisabled() {
    return this.hasAttribute('disabled-animation')
  }
}

customElements.define('animate-on-scroll', AnimateOnScroll)
